@import "../../global/temporary-mercury-overrides/_button.scss";

:host {
  display: grid;
  block-size: 100%;
  grid-template-rows: 1fr max-content;
}

.field-group {
  grid-auto-rows: max-content;
}

.main {
  overflow: auto;
}

.section {
  display: contents;
}

.tooltip {
  position: absolute;
}

.checkbox {
  inline-size: max-content;
}
